import React, { useEffect } from "react";

import QuestionsPage from "../../components/APanel/QuestionEditor/QuestionsPage";

// Admin → Întrebări: editorul unic al biletelor de examen și de teorie.
export default function APQuestions() {
   useEffect(() => {
      document.title = "Instruire Auto | Întrebări";
   }, []);

   return (
      <main className="main">
         <section className="page-wrapper">
            <QuestionsPage />
         </section>
      </main>
   );
}
